import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmsOtpIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#3C3C3C",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.333 13.6663H4.66634C2.66634 13.6663 1.33301 12.6663 1.33301 10.333V5.66634C1.33301 3.33301 2.66634 2.33301 4.66634 2.33301H11.333C13.333 2.33301 14.6663 3.33301 14.6663 5.66634V10.333C14.6663 12.6663 13.333 13.6663 11.333 13.6663Z",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.3337 6L9.24699 7.66667C8.56032 8.21333 7.43366 8.21333 6.74699 7.66667L4.66699 6",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSmsOtpIcon;
